export const MY_LEARNING_TABS = ['all', 'courses-and-lessons', 'videos'];
export const MyLearningTabTypeToLearningContentTypeMapping = {
  all: ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'],
  'courses-and-lessons': ['TRACK', 'LESSON'],
  videos: ['SHORT_FORM_CONTENT']
};